import request from '@api';
import {
  ApiPath, RespCode, NeedShowDeliveryGuarantee, NeedShowWorryFreePurchase, NeedShowMakeItReturnable,
} from '@constants';
// import { MOCK_POLICY_LIST } from './mock';
import { getProductName } from './constants';

/**
 * 请求后台获取 policy list 接口
 * @param {*} body
 * @returns
 */
export const getPolicyListData = (async ({ ...body }, errorConfig) => {
  try {
    const resp = await request(ApiPath.Path.PolicyList, {
      path: ApiPath.Service.MerchantOpenPlatform,
      method: 'POST',
      body,
      ...errorConfig,
    });
    // const resp = MOCK_POLICY_LIST;
    const { code, data = {} } = resp || {};
    if (code !== RespCode.Success) {
      console.log(`getRAPolicyListData error, code=${code}, data=${JSON.stringify(data)}`);
      return null;
    }

    const {
      data: list, currentPage, pageSize, totalItems: totalCount,
    } = data;

    const convertedList = list?.map((item) => {
      const { policyType = '' } = item;
      let type = policyType.toLocaleLowerCase();
      if (/ra/.test(type)) {
        type = 'ra';
      } else if (/[b|s|gs]p/.test(type)) {
        type = 'bp';
      } else if (/as/.test(type)) {
        type = 'as';
      } else if (/ew/.test(type)) {
        type = 'ew';
      } else if (/wfp/.test(type)) {
        type = 'wfp';
      }
      const isShowDeliveryGuarantee = NeedShowDeliveryGuarantee.includes(policyType);
      const isShowWorryFreePurchase = NeedShowWorryFreePurchase.includes(policyType);
      const isShowMakeItReturnable = NeedShowMakeItReturnable.includes(policyType);
      return {
        productName: getProductName(type, isShowDeliveryGuarantee, isShowWorryFreePurchase, isShowMakeItReturnable),
        code: type?.toLocaleUpperCase(), // RA BP AS
        ...item,
      };
    }) || [];

    return {
      list: convertedList, currentPage, pageSize, totalCount,
    };
  } catch (error) {
    console.log('getPolicyListData error', error);
    return null;
  }
});

export const getShoplazzaBPPolicyListData = (async (body, errorConfig) => {
  try {
    const resp = await request(ApiPath.Path.shoplazzaBPPolicyList, {
      path: ApiPath.Service.MerchantOpenPlatform,
      method: 'POST',
      body,
      ...errorConfig,
    });

    const { code, data = {} } = resp || {};

    if (code !== RespCode.Success) {
      console.log(`getBPPolicyListData error, code=${code}, data=${JSON.stringify(data)}`);
      return null;
    }

    const {
      data: list, currentPage, pageSize, totalItems: totalCount,
    } = data;
    return {
      list, currentPage, pageSize, totalCount,
    };
  } catch (error) {
    console.log('getBPPolicyListData error', error);
    return null;
  }
});
